
// User Interface (Minimal Example for Author and Editor)
export class User {
  uid!: string; // Unique identifier for the user
  name!: string; // Name of the user
  email!: string; // Email address of the user
  role!: string; // User role (e.g., 'Author', 'Editor', etc.)
  createdAt!: Date; // Date the user was created
  updateAt!: Date; // Date the user was last updated
  emailVerified!: boolean; // Whether the user's email address has been verified
  avatarUrl!: string; // URL for the user's avatar image
  providerData!: any; // Provider data for the user
  providerId!: string; // Provider ID for the user


  constructor(data: object) {
    Object.assign(this, data);
  }
}
